import "./App.css";
import Page from "./pages/page";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route index element={<Page />} />
          <Route path="/:lang" element={<Page />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
